import { render, staticRenderFns } from "./DisplayArea.vue?vue&type=template&id=de8c3524&scoped=true&"
import script from "./DisplayArea.vue?vue&type=script&lang=js&"
export * from "./DisplayArea.vue?vue&type=script&lang=js&"
import style0 from "./DisplayArea.vue?vue&type=style&index=0&id=de8c3524&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de8c3524",
  null
  
)

export default component.exports